let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j7qo0")).then(() => parcelRequire('5dOp9'));